// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/admin_notification.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/admin_notification.proto.
 */
export const file_v1_admin_notification: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * AdminNotification is the administrator view of a notification. Unlike
 * Notification it carries no per-user read state.
 *
 * @generated from message v1.AdminNotification
 */
export type AdminNotification = Message<"v1.AdminNotification"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * create_date is the display date in YYYY-MM-DD format.
   *
   * @generated from field: string create_date = 4;
   */
  createDate: string;

  /**
   * @generated from field: v1.NotificationAudience audience = 5;
   */
  audience: NotificationAudience;

  /**
   * recipient_usernames is sorted, and empty unless audience is USERS.
   *
   * @generated from field: repeated string recipient_usernames = 6;
   */
  recipientUsernames: string[];
};

/**
 * Describes the message v1.AdminNotification.
 * Use `create(AdminNotificationSchema)` to create a new message.
 */
export const AdminNotificationSchema: GenMessage<AdminNotification> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 0);

/**
 * @generated from message v1.ListAdminNotificationsRequest
 */
export type ListAdminNotificationsRequest = Message<"v1.ListAdminNotificationsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;
};

/**
 * Describes the message v1.ListAdminNotificationsRequest.
 * Use `create(ListAdminNotificationsRequestSchema)` to create a new message.
 */
export const ListAdminNotificationsRequestSchema: GenMessage<ListAdminNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 1);

/**
 * @generated from message v1.ListAdminNotificationsResponse
 */
export type ListAdminNotificationsResponse = Message<"v1.ListAdminNotificationsResponse"> & {
  /**
   * @generated from field: repeated v1.AdminNotification notifications = 1;
   */
  notifications: AdminNotification[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 current_page = 3;
   */
  currentPage: number;

  /**
   * @generated from field: int32 total_pages = 4;
   */
  totalPages: number;
};

/**
 * Describes the message v1.ListAdminNotificationsResponse.
 * Use `create(ListAdminNotificationsResponseSchema)` to create a new message.
 */
export const ListAdminNotificationsResponseSchema: GenMessage<ListAdminNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 2);

/**
 * @generated from message v1.CreateNotificationRequest
 */
export type CreateNotificationRequest = Message<"v1.CreateNotificationRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * create_date is the display date in YYYY-MM-DD format.
   *
   * @generated from field: string create_date = 3;
   */
  createDate: string;

  /**
   * @generated from field: v1.NotificationAudience audience = 4;
   */
  audience: NotificationAudience;

  /**
   * recipient_usernames is required when audience is USERS and ignored otherwise.
   *
   * @generated from field: repeated string recipient_usernames = 5;
   */
  recipientUsernames: string[];
};

/**
 * Describes the message v1.CreateNotificationRequest.
 * Use `create(CreateNotificationRequestSchema)` to create a new message.
 */
export const CreateNotificationRequestSchema: GenMessage<CreateNotificationRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 3);

/**
 * @generated from message v1.CreateNotificationResponse
 */
export type CreateNotificationResponse = Message<"v1.CreateNotificationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.AdminNotification notification = 3;
   */
  notification?: AdminNotification;
};

/**
 * Describes the message v1.CreateNotificationResponse.
 * Use `create(CreateNotificationResponseSchema)` to create a new message.
 */
export const CreateNotificationResponseSchema: GenMessage<CreateNotificationResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 4);

/**
 * @generated from message v1.UpdateNotificationRequest
 */
export type UpdateNotificationRequest = Message<"v1.UpdateNotificationRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * create_date is the display date in YYYY-MM-DD format.
   *
   * @generated from field: string create_date = 4;
   */
  createDate: string;

  /**
   * @generated from field: v1.NotificationAudience audience = 5;
   */
  audience: NotificationAudience;

  /**
   * recipient_usernames is required when audience is USERS and ignored otherwise.
   *
   * @generated from field: repeated string recipient_usernames = 6;
   */
  recipientUsernames: string[];
};

/**
 * Describes the message v1.UpdateNotificationRequest.
 * Use `create(UpdateNotificationRequestSchema)` to create a new message.
 */
export const UpdateNotificationRequestSchema: GenMessage<UpdateNotificationRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 5);

/**
 * @generated from message v1.UpdateNotificationResponse
 */
export type UpdateNotificationResponse = Message<"v1.UpdateNotificationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.AdminNotification notification = 3;
   */
  notification?: AdminNotification;
};

/**
 * Describes the message v1.UpdateNotificationResponse.
 * Use `create(UpdateNotificationResponseSchema)` to create a new message.
 */
export const UpdateNotificationResponseSchema: GenMessage<UpdateNotificationResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 6);

/**
 * @generated from message v1.DeleteNotificationRequest
 */
export type DeleteNotificationRequest = Message<"v1.DeleteNotificationRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.DeleteNotificationRequest.
 * Use `create(DeleteNotificationRequestSchema)` to create a new message.
 */
export const DeleteNotificationRequestSchema: GenMessage<DeleteNotificationRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 7);

/**
 * @generated from message v1.DeleteNotificationResponse
 */
export type DeleteNotificationResponse = Message<"v1.DeleteNotificationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.DeleteNotificationResponse.
 * Use `create(DeleteNotificationResponseSchema)` to create a new message.
 */
export const DeleteNotificationResponseSchema: GenMessage<DeleteNotificationResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_notification, 8);

/**
 * NotificationAudience selects who can see a notification.
 *
 * @generated from enum v1.NotificationAudience
 */
export enum NotificationAudience {
  /**
   * Treated as NOTIFICATION_AUDIENCE_ALL, so older clients keep their behaviour.
   *
   * @generated from enum value: NOTIFICATION_AUDIENCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Every user sees the notification.
   *
   * @generated from enum value: NOTIFICATION_AUDIENCE_ALL = 1;
   */
  ALL = 1,

  /**
   * Only the users in recipient_usernames see the notification.
   *
   * @generated from enum value: NOTIFICATION_AUDIENCE_USERS = 2;
   */
  USERS = 2,
}

/**
 * Describes the enum v1.NotificationAudience.
 */
export const NotificationAudienceSchema: GenEnum<NotificationAudience> = /*@__PURE__*/
  enumDesc(file_v1_admin_notification, 0);

/**
 * AdminNotificationService exposes the administrator-only CRUD operations for
 * notifications. Read access for regular users lives in NotificationService.
 *
 * @generated from service v1.AdminNotificationService
 */
export const AdminNotificationService: GenService<{
  /**
   * @generated from rpc v1.AdminNotificationService.ListAdminNotifications
   */
  listAdminNotifications: {
    methodKind: "unary";
    input: typeof ListAdminNotificationsRequestSchema;
    output: typeof ListAdminNotificationsResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminNotificationService.CreateNotification
   */
  createNotification: {
    methodKind: "unary";
    input: typeof CreateNotificationRequestSchema;
    output: typeof CreateNotificationResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminNotificationService.UpdateNotification
   */
  updateNotification: {
    methodKind: "unary";
    input: typeof UpdateNotificationRequestSchema;
    output: typeof UpdateNotificationResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminNotificationService.DeleteNotification
   */
  deleteNotification: {
    methodKind: "unary";
    input: typeof DeleteNotificationRequestSchema;
    output: typeof DeleteNotificationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_admin_notification, 0);

